import { createBrowserHistory } from 'history';

const appHistory = createBrowserHistory();

if ((window as any).Cypress) {
  (window as any).__cyBrowserHistory = appHistory;
}

export default appHistory;
